<template>
	<!--
    Usage:

    The inner slot is for placeholder text, usually the default text is fine.
    The text is only shown to screen reader users, since the text color is
    transparent! Regular visual browsers instead see an animated block - you
    need to set the width and height of this component with CSS every time!

    The `role="status"` + the placeholder text should be enough for screen
    reader users to know that this is a temporary loading element. The screen
    reader won't make an extra announcement on a focused element when the
    content comes in (that would require `aria-live` attribute in the
    placeholder's parent), but this should be fine assuming that our
    placeholdered content loads pretty fast, since screen reader users should
    be used to re-checking loading content after a while.

    If you use this component to create animated boxes for a loading skeleton,
    you should make sure their parent container or they themselves have
    `aria-hidden="true"` set! Otherwise screen readers will pointlessly go
    through each placeholder box and read their identical loading texts. Also
    supply a separate `sr-only` class element with a loading text.
    -->
	<div
		class="relative isolate overflow-hidden text-transparent select-none before:absolute before:inset-0 before:animate-shimmer before:bg-linear-to-r before:from-transparent before:to-transparent"
		role="status"
	>
		<slot>
			{{ tg("loading") }}
		</slot>
	</div>
</template>

<script setup lang="ts">
const {t: tg} = useI18n({useScope: "global"});
</script>
